import cx from 'classnames';
import PropTypes from 'prop-types';

import x from '../../images/x.svg';
import TabButton from './tabbutton';
import * as style from './searchbar.module.scss';

const inputId = 'search-bar-input';

const SearchBar = ({ className, closeSearch, searchText, setSearchText }) => {
  return (
    <div className={cx(className, style.searchBar)}>
      <label className={style.prompt} htmlFor={inputId}>
        <strong>Search</strong>
        <span className={style.promptExtra}>
          &nbsp;Search&nbsp;for&nbsp;what&nbsp;you’d&nbsp;like&nbsp;resistbot&nbsp;to&nbsp;do:
        </span>
      </label>
      <div className={style.inputs}>
        <input
          aria-label="Search resistbot commands"
          className={style.searchInput}
          id={inputId}
          onChange={(event) => setSearchText(event.target.value)}
          onKeyDown={(event) => {
            // Escape key
            if (event.keyCode === 27) {
              closeSearch();
            }
          }}
          ref={(input) => input?.focus()}
          type="text"
          value={searchText}
        />
        <TabButton
          aria-label="Close search"
          className={style.closer}
          onClick={closeSearch}
        >
          <img alt="" src={x} />
        </TabButton>
      </div>
    </div>
  );
};

SearchBar.propTypes = {
  className: PropTypes.string,
  closeSearch: PropTypes.func.isRequired,
  searchText: PropTypes.string.isRequired,
  setSearchText: PropTypes.func.isRequired,
};

export default SearchBar;
